import React from 'react'
import { DropdownCustom2Styled } from './styled'
import cx from "classnames";

export const DropdownCustom2 = ({ theme_standard, dataDropDown, disabled, input, onChange, value }) => {
    const customClass = cx({
        "theme_standard": theme_standard
    })

    return (
        <DropdownCustom2Styled>
            <div className={customClass}>
                <select {...input} className="select_item" disabled={disabled} onChange={onChange} value={value && value} >
                    {
                        dataDropDown &&
                        dataDropDown.length > 0 &&
                        (
                            dataDropDown.map((e, i) => (
                                <option key={i} value={e.value}>{e.label}</option>
                            ))
                        )

                    }
                </select>
            </div>
        </DropdownCustom2Styled>
    )
}